import React, { FC } from 'react';
import type { Animation as AnimationFields } from '@/generated/graphql';

interface AnimationPlayerProps {
    uniqueId: string | number;
    initialImageUrl: string;
    fields: AnimationFields;
}

const AnimationPlayer: FC<AnimationPlayerProps> = ({
    uniqueId,
    initialImageUrl,
    fields,
}) => {
    return (
        <>
            <div className="Animation_canvasBox">
                <canvas
                    id={`AnimationCanvas_${uniqueId}`}
                    className="Animation_canvas"
                />
            </div>

            <div id={`AnimationStill_${uniqueId}`} className="Animation_still">
                <img
                    className="Animation_img"
                    id={`AnimationInitImg_${uniqueId}`}
                    src={initialImageUrl}
                    alt={fields.caption || ''}
                    width={fields.w}
                    height={fields.h}
                    style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                    }}
                />
            </div>
        </>
    );
};

export default AnimationPlayer;
